import { Tabs } from "antd";
import { useState } from "react";
import Router from "../..";

export const InfluencerDashboard = () => {
  const tabParam = new URLSearchParams(window.location.search).get("tab");
  const requestedTab =
    tabParam === "instagram" || tabParam === "youtube" ? tabParam : "tiktok";

  const [activeTab, setActiveTab] = useState(requestedTab);

  const tabItems = [
    {
      key: "tiktok",
      label: "틱톡",
      children: <Router.TiktokTabContent />,
    },
    {
      key: "instagram",
      label: "인스타그램",
      children: <Router.InstagramTabContent />,
    },
    {
      key: "youtube",
      label: "유튜브",
      children: <Router.YoutubeTabContent />,
    },
  ];

  return (
    <div className="w-full">
      <h2 className="md:text-4xl text-3xl font-bold">소셜 연동 관리</h2>

      <div className="flex flex-col">
        <Tabs
          className="dashboard-tabs"
          type="card"
          items={tabItems}
          activeKey={activeTab}
          onChange={setActiveTab}
        />
      </div>
    </div>
  );
};
